<template>
    <div class="puzzle-captcha-container">
      <label>Vérification : Placez la pièce manquante</label>
      <div class="puzzle-board" ref="puzzleBoard">
        <div class="puzzle-image" :style="{ 
          backgroundImage: `url(${puzzleImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }">
          <div class="puzzle-hole" :style="{ top: `${holePosition.y}px`, left: `${holePosition.x}px` }"></div>
        </div>
        <div class="puzzle-piece" 
            :style="{ top: `${piecePosition.y}px`, left: `${piecePosition.x}px` }"
            @mousedown="startDrag"
            @touchstart="startDrag"
            ref="puzzlePiece">
            <div class="piece-content">
                <div :style="{
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${puzzleImage})`,
                    backgroundSize: `${boardWidth}px ${boardHeight}px`,
                    backgroundPosition: `-${holePosition.x - marginLeft}px -${holePosition.y - marginTop}px`,
                    transform: 'none'
                }"></div>
            </div>
        </div>
    </div>
      <input type="hidden" :value="isValid ? 'valid' : ''" name="puzzle_verification">
      <input type="hidden" :value="holePosition.x + ',' + holePosition.y" name="puzzle_hole_position">
      <input type="hidden" :value="piecePosition.x + ',' + piecePosition.y" name="puzzle_piece_position">
    </div>
  </template>
  
  <script>
  export default {
    name: 'PuzzleCaptcha',
    props: {
      puzzleImage: {
        type: String,
        required: true,
        default: '/puzzle-captcha.jpg'
      }
    },
    emits: ['verification-change'],
    data() {
        return {
            holePosition: { x: 0, y: 0 },
            piecePosition: { x: 0, y: 0 },
            //startPosition: { x: 0, y: 0 },
            isDragging: false,
            dragOffset: { x: 0, y: 0 },
            isValid: false,
            boardWidth: 0,
            boardHeight: 0,
            marginLeft: 0,
            marginTop: 0
        }
    },
    mounted() {
        // Attendre que l'image soit chargée
        setTimeout(() => {
            const board = this.$refs.puzzleBoard;
            const boardRect = board.getBoundingClientRect();
            const pieceSize = 60;
            
            // Calculer la taille réelle de l'image
            const img = new Image();
            img.src = this.puzzleImage;
            img.onload = () => {
            // Calculer le ratio d'aspect
            const imgRatio = img.width / img.height;
            const boardRatio = boardRect.width / boardRect.height;
            
            let displayedWidth, displayedHeight;
            if (boardRatio > imgRatio) {
                // La hauteur est limitante
                displayedHeight = boardRect.height;
                displayedWidth = displayedHeight * imgRatio;
            } else {
                // La largeur est limitante
                displayedWidth = boardRect.width;
                displayedHeight = displayedWidth / imgRatio;
            }
            
            // Calculer les marges
            const marginLeft = (boardRect.width - displayedWidth) / 2;
            const marginTop = (boardRect.height - displayedHeight) / 2;
            
            // Position du trou (éviter les bords)
            //const maxX = displayedWidth - pieceSize - 20;
            //const maxY = displayedHeight - pieceSize - 20;
            // Stockez les marges dans les données
            this.marginLeft = marginLeft;
            this.marginTop = marginTop;

            // Calculez la position du trou SUR L'IMAGE (sans les marges)
            const holeX = Math.floor(Math.random() * (displayedWidth - 60));
            const holeY = Math.floor(Math.random() * (displayedHeight - 60));

            // Position finale du trou (avec marges ajoutées)
            this.holePosition = {
                x: this.marginLeft + holeX,
                y: this.marginTop + holeY
            };

            
            // Position initiale de la pièce
            this.piecePosition = {
                x: boardRect.width - pieceSize - 10,
                y: 10
            };
            
            // Stocker les dimensions pour le backgroundSize
            this.boardWidth = displayedWidth;
            this.boardHeight = displayedHeight;
            };
        }, 100);
        
        // Ajouter les événements globaux
        window.addEventListener('mousemove', this.onDrag);
        window.addEventListener('touchmove', this.onTouchDrag);
        window.addEventListener('mouseup', this.stopDrag);
        window.addEventListener('touchend', this.stopDrag);
        },
    beforeUnmount() {
      // Nettoyer les événements
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('touchmove', this.onTouchDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchend', this.stopDrag);
    },
    methods: {
      startDrag(event) {
        if (event.touches) {
          event.preventDefault();
        }
        
        this.isDragging = true;
        const piece = this.$refs.puzzlePiece;
        const pieceRect = piece.getBoundingClientRect();
        
        if (event.type === 'mousedown') {
          this.dragOffset = {
            x: event.clientX - pieceRect.left,
            y: event.clientY - pieceRect.top
          };
        } else if (event.type === 'touchstart') {
          this.dragOffset = {
            x: event.touches[0].clientX - pieceRect.left,
            y: event.touches[0].clientY - pieceRect.top
          };
        }
      },
      onDrag(event) {
        if (!this.isDragging) return;
        
        const board = this.$refs.puzzleBoard;
        const boardRect = board.getBoundingClientRect();
        
        // Mettre à jour la position de la pièce
        this.piecePosition = {
          x: Math.max(0, Math.min(boardRect.width - 60, event.clientX - boardRect.left - this.dragOffset.x)),
          y: Math.max(0, Math.min(boardRect.height - 60, event.clientY - boardRect.top - this.dragOffset.y))
        };
        
        this.checkPosition();
      },
      onTouchDrag(event) {
        if (!this.isDragging) return;
        
        const board = this.$refs.puzzleBoard;
        const boardRect = board.getBoundingClientRect();
        
        // Mettre à jour la position de la pièce
        this.piecePosition = {
          x: Math.max(0, Math.min(boardRect.width - 60, event.touches[0].clientX - boardRect.left - this.dragOffset.x)),
          y: Math.max(0, Math.min(boardRect.height - 60, event.touches[0].clientY - boardRect.top - this.dragOffset.y))
        };
        
        this.checkPosition();
      },
      stopDrag() {
        if (!this.isDragging) return;
        
        this.isDragging = false;
        this.checkPosition();
      },
      checkPosition() {
        // Tolérance en pixels
        const tolerance = 15;
        
        // Vérifier si la pièce est correctement placée
        const isCorrectX = Math.abs(this.piecePosition.x - this.holePosition.x) < tolerance;
        const isCorrectY = Math.abs(this.piecePosition.y - this.holePosition.y) < tolerance;
        
        if (isCorrectX && isCorrectY) {
          // Ajuster la position pour qu'elle soit parfaitement alignée
          this.piecePosition = { ...this.holePosition };
          this.isValid = true;
        } else {
          this.isValid = false;
        }
        
        // Émettre l'événement
        this.$emit('verification-change', this.isValid);
      }
    }
  }
  </script>
  
  <style scoped>
  .puzzle-captcha-container {
    margin: 20px 0;
    width: 100%;
  }
  
  .puzzle-board {
  position: relative;
  width: 100%;
  height: 200px;
  margin: 10px 0;
  border-radius: 4px;
  overflow: hidden;
 }
  
  .puzzle-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
 }

  
 .puzzle-piece {
  position: absolute;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  cursor: move;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: 2px solid #4a90e2;
  border-radius: 2px;
  transition: box-shadow 0.2s;
  z-index: 10;
  overflow: hidden;
}


  .puzzle-piece:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }


  .puzzle-hole {
  position: absolute;
  width: 60px;
  height: 60px;
  background-color: white; /* Blanc opaque au lieu de semi-transparent */
  border: 2px dashed red;
  box-sizing: border-box;
  z-index: 5; /* Assure que le trou est au-dessus de l'image mais sous la pièce */
}

 .piece-content {
  width: 100%;
  height: 100%;
  position: relative;
 }

  </style>


